// OpenSearch 검색 → 기존 JMAP requestThread 출력 계약으로 변환 (OFM-212)
//
// requestThread(jamUtil)에서 검색 모드일 때 이 경로로 분기한다.
// 결과 표시/무한스크롤/상세 진입 파이프라인을 그대로 재사용하기 위해,
// OpenSearch hit을 JMAP Email 데이터와 동일한 형태로 어댑팅하여 반환한다.
import { searchEmails } from 'services/openSearch'

import { MAX_RESULT_WINDOW, buildPathMaps, computeFolderIds, adaptHit } from './openSearchMap'
import type { AdaptedEmailData } from './openSearchMap'

interface RequestThreadResult {
  emailIds: string[]
  allEmailList: AdaptedEmailData[]
  total: number
  info: { lastState: null; lastQueryState: null; enableQueryChange: false }
}

export async function requestThreadOpenSearch(
  mailbox: any,
  options: any,
): Promise<RequestThreadResult> {
  const dataMgr = mailbox.dataMgr
  const { pathToUuid } = buildPathMaps(dataMgr)
  const folderIds = computeFolderIds(mailbox, dataMgr)

  const position = options.position || 0
  const baseLimit = options.limit || 10
  // 10000 window 초과 방지: position+limit를 window로 클램프.
  // 마지막 페이지에서 반환 hit < baseLimit → reqNextThreadList의 hasMoreData(length===limit)가 false.
  const limit = Math.max(0, Math.min(baseLimit, MAX_RESULT_WINDOW - position))

  if (limit === 0) {
    return {
      emailIds: [],
      allEmailList: [],
      total: 0,
      info: { lastState: null, lastQueryState: null, enableQueryChange: false },
    }
  }

  const filter: { keyword?: string; folderIds?: string[] } = {}
  if (options.text != null && options.text.length > 0) {
    filter.keyword = options.text
  }
  if (folderIds.length > 0) {
    filter.folderIds = folderIds
  }

  const res = await searchEmails({
    filter,
    sort: 'receivedAt:desc',
    position,
    limit,
  })

  const allEmailList: AdaptedEmailData[] = res.hits
    .map((hit) => adaptHit(hit, pathToUuid))
    .filter((data): data is AdaptedEmailData => data != null)

  return {
    emailIds: allEmailList.map((data) => data.id),
    allEmailList,
    total: res.total,
    info: { lastState: null, lastQueryState: null, enableQueryChange: false },
  }
}
